import { useParams } from 'react-router-dom'
import { useGetActiveCustomer } from '@/shared-queries/customers'
import {
  useGetQuote,
  useGetQuoteApprovers
} from '@/pages/quotation-tool/queries/quoteQueries'

export const useQuoteData = () => {
  const { quoteId } = useParams()

  const { data: quote = {} } = useGetQuote(quoteId)
  const { quotation = {}, quotationPriceNew = {} } = quote

  const customerId = quotation?.customerId
  const { data: customer = {} } = useGetActiveCustomer(Number(customerId))

  const { data: approvers = {} } = useGetQuoteApprovers()

  return {
    quote,
    quotation,
    quotationPriceNew,
    customer,
    quoteId,
    approvers
  }
}
